/* eslint-disable @typescript-eslint/no-explicit-any */

export enum ComparisonOperators {
  Equals = '$EQ',
  NotEqual = '$NE',
  GreaterThanOrEqual = '$GE',
  LessThanOrEqual = '$LE',
  GreaterThan = '$GT',
  LessThan = '$LT',
  In = '$IN',
  NotIn = '$NIN',
  All = '$ALL',
  Like = '$LIKE',
  NotLike = '$NLIKE',
  Range = '$RANGE',
  NotRange = '$NRANGE',
  Exists = '$EXISTS',
  NotExists = '$NEXISTS',
  Tree = '$TREE',
}

export enum LogicalOperators {
  And = '$AND',
  Or = '$OR',
  Union = '$UNION',
}

export enum PhraseOperators {
  Phrase = '$PHRASE',
}

export type ComparisonOperator = `${ComparisonOperators}`;

export type ComparisonValue = {
  [K in ComparisonOperator]?: any;
};

export type ComparisonObject<T> = {
  [K in ComparisonOperator]?: {
    [P in keyof T]?: any;
  };
};

export type LogicalOperator = `${LogicalOperators}`;
export type PhraseOperator = `${PhraseOperators}`;

export type UntypedQuery = {
  [key: string]: ComparisonObject<any> | LogicalQuery<any> | ComparisonValue;
};

export type Query<T> = {
  [K in keyof T]?: T[K] extends object
    ? ComparisonObject<T[K]> | ComparisonObject<string[]> | LogicalQuery<T[K]>
    : ComparisonValue;
};

export type LogicalQuery<T> = {
  [K in LogicalOperator]?: SearchQuery<T>[];
};

export type PhraseQuery = {
  [K in PhraseOperator]?: string;
};

export type ExistQuery<T> = {
  [K in string]: {
    Field: string;
    Query: SearchQuery<T>;
  };
};

export type SearchQuery<T> =
  | Query<T>
  | UntypedQuery
  | LogicalQuery<T>
  | PhraseQuery
  | ExistQuery<T>;

export interface Criteria<T> {
  SearchQuery: SearchQuery<T>;
  Top?: number;
}
